/**
 *  Module for model and alternate views display
 */

const Thumbnails = function(app) {

  const $ = require('jquery');

  /**
   *  Private Properties/Methods
   */
  const configure = app.configure;

  function init() {
    const options = {
      type: 'thumbnailsDisplay',
      container: '.fc-thumbnails-container',
      viewNames: app.views,
      backgroundColor: app.backgroundColor,
      arrows: false,
      containerPadding: 0,
      selectedView: 'front',
      format: 'jpg'
    };

    configure.run('createComponent', options, function(err, thumbnailsDisplay) {
      if ( !app.mergedParams.showThumbnails ) {
        // When each thumbnail image is loaded
        thumbnailsDisplay.on('image:loaded', function(image) {
          // Check the pixel data to see if our thumbnail is blank
          app.appUtils.checkPixelColor({
            height: image.img.naturalHeight,
            src: image.img.src,
            width: image.img.naturalWidth
          }, function(imageIsBlank) {
            // Cache a jQuery object of the image's parent DIV
            const $thumbnailImage = $(image.img).parent();

            // If the image is blank we hide it, otherwise
            // we show it
            if ( imageIsBlank ) {
              $thumbnailImage.hide();
              console.warn('Note: The thumbnail image for ', app.utils.getUrlParam('view', image.img.src), 'has been removed because the image is blank', image.img.src);
            } else {
              $thumbnailImage.show();
            }
          });
        });
      }
    });
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init
  };
};

module.exports = Thumbnails;
